import { render, staticRenderFns } from "./code_remark.vue?vue&type=template&id=aa581720"
import script from "./code_remark.vue?vue&type=script&lang=js"
export * from "./code_remark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports